import React, { forwardRef } from "react";
import { Search, X, Loader2 } from "lucide-react";

const CommandInput = forwardRef(function CommandInput({ value, onChange, loading, onClose }, ref) {
  return (
    <div className="flex items-center gap-3 px-4 py-3 border-b border-[#E2E8F0] dark:border-slate-700">
      <Search className="w-5 h-5 text-[#475569] dark:text-slate-400" />
      <input
        ref={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search clients, projects, work orders, invoices, estimates…"
        data-testid="cmdk-input"
        className="flex-1 bg-transparent text-[#0A2540] dark:text-white outline-none placeholder:text-[#94A3B8]"
      />
      {loading && <Loader2 className="w-4 h-4 animate-spin text-[#C9A356]" />}
      <kbd className="hidden sm:inline-block text-[10px] uppercase tracking-wider font-mono px-1.5 py-0.5 rounded border border-[#E2E8F0] dark:border-slate-600 text-[#475569] dark:text-slate-300">ESC</kbd>
      <button onClick={onClose} aria-label="Close" className="text-[#475569] hover:text-[#0A2540] dark:text-slate-400 dark:hover:text-white">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
});

export default CommandInput;
